module.exports = __webpack_public_path__ + "static/media/video_1.313097c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_9/video_1.mp4
// module id = 03fy
// module chunks = 0